<template>
  <div>
    <div class="rounded-lg golden-border">
      <div class="border-gray-bottom d-flex justify-center">
        <h1 class="text-h4-center my-4 gold--text">
          {{ $t("history.title") }}
        </h1>
      </div>
    </div>
    <div style="max-width: 600px" v-if="items.length" class="mt-1">
      <v-card class="rounded-lg mt-5">
        <v-list dense>
          <v-list-item-group
            v-model="selectedItem"
            @change="selectedHistory"
            color="primary"
          >
            <v-list-item v-for="(item, i) in items" :key="i">
              <v-list-item-icon>
                <v-icon v-text="'mdi-history'"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.name"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </div>
    <div
      v-else
      style="max-width: 600px"
      class="d-flex justify-center align-center no-history"
    >
      <div>
        {{ $t("history.noHistory") }}
      </div>
    </div>
  </div>
</template>
<script>
import googleMap from "@/mixins/googleMap"
export default {
  name: "history",
  data() {
    return {
      items: [],
      selectedItem: null,
    }
  },
  mixins: [googleMap],
  computed: {
    points() {
      return this.$store.getters.points
    },
  },
  methods: {
    selectedHistory(selected) {
      this.$store.commit("point/set", this.items[selected])
      this.$router.push({
        name: "Dashboard",
        params: { isFromHistory: true },
      })
    },
    async loadData() {
      if (!this.points.length) {
        await this.$store.dispatch("point/index")
      }
    },
  },
  async mounted() {
    await this.loadData()
    let history = localStorage.getItem("search history")
    if (history) {
      this.items = JSON.parse(localStorage.getItem("search history"))
        .map((h) => this.$store.getters.pointById(h))
        .filter((i) => i)
    }
  },
}
</script>
<style scoped lang="scss">
.no-history {
  margin: 20% auto;
}
.golden-border {
  border: 2px solid var(--golden);
}
.border-gray-bottom {
  border-bottom: 1px solid var(--lightGrey);
}
</style>
